import { ButtonItem, Form, FormRef, GroupItem, RequiredRule, SimpleItem } from 'devextreme-react/form'
import { useRef, useState } from 'react'
import '../SoftwarePage.scss'
import { ArraySourceComposer } from '@/auth/api/connector'
import LoadingPanel from '@/components/loading-panel/LoadingPanel'
import { Popup } from 'devextreme-react'
import { useScreenSize } from '@/themes/media-query'
import { useQsAdminApiManager } from '@/auth/api/qsadminapiManager'
import { qs_licenza, qs_versione } from '@/model/qsadminapi/QsAdminApiModuleModel'
import { PopupRef } from 'devextreme-react/cjs/popup'
import LoadPanel, { LoadPanelRef } from 'devextreme-react/cjs/load-panel'
import { ClickEvent } from 'devextreme/ui/button'
import notify from 'devextreme/ui/notify'
import { DataGridRef } from 'devextreme-react/cjs/data-grid'

type SoftwareQsVersionUpdaterSelectorProps = {
  popupRef: React.RefObject<PopupRef>
  versioni: qs_versione[]
  gridRef?: React.RefObject<DataGridRef>
}

const SoftwareQsVersionUpdaterSelector = (props: SoftwareQsVersionUpdaterSelectorProps) => {
  const { popupRef, versioni, gridRef } = props
  const formRef = useRef<FormRef>(null)
  const currentScreenSize = useScreenSize()
  const { client } = useQsAdminApiManager()
  const loadPanelRef = useRef<LoadPanelRef>(null)

  const formData: {
    version: qs_versione
  } = {
    version: versioni[0],
  }

  return (
    <>
      <Popup
        width={currentScreenSize.isLarge || currentScreenSize.isMedium ? 500 : currentScreenSize.isXSmall ? 350 : 700}
        height={currentScreenSize.isSmall ? 320 : currentScreenSize.isXSmall ? 720 : 'auto'}
        hideOnOutsideClick={true}
        title="Aggiorna Versione"
        showCloseButton={true}
        deferRendering={true}
        ref={popupRef}
        resizeEnabled={false}
      >
        <div id="update-version-qs-license-form-container" className={'dx-card responsive-paddings'}>
          <LoadPanel
            ref={loadPanelRef}
            shadingColor="rgba(0,0,0,0.4)"
            showIndicator={true}
            shading={true}
            showPane={true}
            hideOnOutsideClick={false}
            hideOnParentScroll={false}
            position={{ of: '#update-version-qs-license-form-container' }}
          />

          <Form
            id={`update-version-qs-license-form`}
            key={`update-version-qs-license-form`}
            formData={formData}
            ref={formRef}
            validationGroup="updateVersioneQsLicenseDataValidation"
          >
            <GroupItem colCount={1}>
              <SimpleItem
                dataField="version"
                label={{ text: 'Versione' }}
                editorType="dxLookup"
                editorOptions={{
                  dataSource: ArraySourceComposer('id', versioni),
                  placeholder: 'Seleziona la versione...',
                  displayExpr: 'major',
                  searchEnabled: true,
                  dropDownCentered: true,
                  dropDownOptions: {
                    showTitle: true,
                    title: 'Selezionare la versione',
                    hideOnOutsideClick: true,
                  },
                }}
              >
                <RequiredRule message="La definizione della versione è obbligatoria" />
              </SimpleItem>
            </GroupItem>
            <GroupItem cssClass="last-group">
              <GroupItem cssClass="buttons-group" colCount={1}>
                <ButtonItem
                  name="btn-compute"
                  buttonOptions={{
                    icon: 'fas fa-arrow-up',
                    text: 'Aggiorna',
                    width: '150px',
                    onClick: async (e: ClickEvent) => {
                      const validationResult = formRef.current?.instance().validate()
                      if (!validationResult?.isValid) return
                      loadPanelRef.current?.instance().option('visible', true)
                      try {
                        const response = await client.put(
                          '/api/qslicenza/updateversion',
                          {
                            qs_licenses: gridRef?.current?.instance().getSelectedRowsData(),
                            qs_version: formData.version,
                          },
                          {
                            headers: {
                              'Content-Type': 'application/json',
                            },
                          },
                        )
                        if (gridRef) {
                          gridRef.current?.instance().clearSelection()
                          gridRef.current?.instance().refresh()
                        }
                        notify(`Aggiornamento licenze avvenuto correttamente.`, 'success', 3000)
                      } catch (error: unknown) {
                        notify(`Errore aggiornamento versione. Dettagli: ${error}`, 'error', 3000)
                      } finally {
                        loadPanelRef.current?.instance().option('visible', false)
                        popupRef.current?.instance().hide()
                      }
                    },
                  }}
                ></ButtonItem>
              </GroupItem>
            </GroupItem>
          </Form>
        </div>
      </Popup>
    </>
  )
}

export default SoftwareQsVersionUpdaterSelector
